// frontend/src/components/common/appToastBus.js
//
// The app's one toast: every page, dialog, hook and tile calls showToast and
// <AppToast> (mounted once in App.jsx above every tab) renders it in one
// place, in one look, for one hold time. Nothing else owns a <Snackbar>.
//
// A window event rather than a context: the emitter needs no import from the
// listener's tree, the message outlives the page that raised it (a save that
// opened another tab, a delete that closed its own), and a component that
// owns no page (a dialog, a Home tile) needs no plumbing.
//
// Callers translate before calling — the bus carries display text, not keys,
// so it stays free of i18n and of any page's vocabulary.

export const APP_TOAST_EVENT = 'manexys:app-toast';

/**
 * @param {string} message  translated display text
 * @param {'success' | 'info' | 'warning' | 'error'} [severity]
 * @param {{ label: string, onClick: Function }} [action]  the one next step,
 *   shown as a button beside the X; clicking it also closes the toast
 */
export function showToast(message, severity = 'success', action) {
  window.dispatchEvent(new CustomEvent(APP_TOAST_EVENT, { detail: { message, severity, action } }));
}
